<template>
    <base-side-bar>
        <div class="flex flex-col items-center justify-center w-full mx-10">
            <wide-card title="Analyse concurrentielle" titleClass="text-center">
                <!-- <pdf :src="src" v-for="i in numPages" :key="i" :page="i"></pdf> -->
                <img :src="url" />
                <div v-if="notFound">
                    <h2
                        class="text-xl font-extrabold leading-9 text-center text-blue-600 sm:text-xl sm:leading-10"
                    >
                        L'étude de marché de ce secteur sera <br />
                        <span class="text-blue-700"
                            >DISPONIBLE PROCHAINEMENT !</span
                        >
                    </h2>
                </div>
            </wide-card>
            <base-primary-button title="Suivant" @click="nextStep" />
        </div>
    </base-side-bar>
</template>

<script>
import WideCard from "../../../components/cards/wideCard";
// import pdf from "vue-pdf";
import { mapGetters } from "vuex";
import { storage } from "@/services/firebase.service";

// const loadingTask = pdf.createLoadingTask("/analyse-concurrentielle.pdf");

export default {
    components: {
        WideCard
        // pdf,
    },
    created() {
        this.$store.dispatch("forms/showSection", "Étude de marché");
        this.$store.dispatch("forms/stepFocus", "Analyse Concurrentielle");

        let imagePath;
        if (this.isSimplifiedVersion) {
            imagePath = `gs://cri-bpi.appspot.com/market-research/simplified-version/${this.getSelectedActivities.temp_id}/2.jpg`;
        } else {
            imagePath = `gs://cri-bpi.appspot.com/market-research/detailed-version/${this.getSelectedActivities.temp_id}/4.jpg`;
        }

        const storageRef = storage.refFromURL(imagePath);
        storageRef
            .getDownloadURL()
            .then(url => {
                this.url = url;
            })
            .catch(error => {
                switch (error.code) {
                    case "storage/object-not-found":
                        this.notFound = true;
                        this.url = "/disponiblesoon.png";
                        break;
                }
            });
    },
    mounted() {
        // this.src.promise.then((pdf) => {
        //   this.numPages = pdf.numPages;
        // });
    },
    data() {
        return {
            //  page: 1,
            // src: loadingTask,
            // numPages: undefined,
            url: "",
            notFound: false
        };
    },
    methods: {
        nextStep() {
            this.$store.dispatch(
                "forms/subStepComplete",
                "Analyse Concurrentielle"
            );
            if (this.isSimplifiedVersion) {
                this.$router.push({
                    name: "geographical_distribution",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.$router.push({
                    name: "moyens_commerciaux",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            }
        }
    },
    computed: {
        ...mapGetters("user", {
            isSimplifiedVersion: "isSimplifiedVersion"
        }),
        ...mapGetters("VotreProject", {
            getSelectedActivities: "getSelectedActivities"
        })
    }
};
</script>
<style>
.multiselect__tag {
    border-radius: 15px;
}
</style>
